const initialState = {
    submitorderresponse: null
}

function commonValues(state = initialState, action) {
    switch (action.type) {
        case 'SUBMIT_ORDER_RESPONSE':
            return Object.assign({}, state, {
                submitorderresponse: action.value
        })
        
        default:
            return state
    }
}

export default commonValues